import {useSafeFeatureFlags} from 'bigdatr-style';

export default function useFeatureFlags() {
    const flags: FeatureFlags = useSafeFeatureFlags();
    return flags;
}

// The base type of LDFlagSet is just {[key: string]: any}
// We'll need to manually update the flags we use here.
// Make sure all new flags are typed to possibly be undefined
type FeatureFlags = {
    enableMediaValueCsvDownloads?: boolean;
    newReportItems?: boolean;
    mediaValueIndex?: boolean;
    embedReportItem?: boolean;
    showJapaneseCreatives?: boolean;
    showIndianCreatives?: boolean;
    showConnectedTvMediaType?: boolean;
    hideCategoryOnNz?: boolean;
    productionisedCompliance?: boolean;
    complianceReviewFeature?: boolean;
    cursorBasedComplianceList?: boolean;
    fuelType?: boolean;
};
